import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { DataService } from '../../services/data_service';
import { DateneingabeBetrieblicheDatenWeitereGewerke } from './DateneingabeBetrieblicheDatenWeitereGewerke';
import { EditUser } from '../../login/EditUser';
import { FormBtnTochtergesellschaften } from './dialogs/FormBtnTochtergesellschaften';
import { getGewerkName, getWZobject } from '../../main/functions/getGewerk';
import { getWetterstation } from './functions/getWetterstation';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormData } from '../../core/forms/WFormData';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface DateneingabeBetrieblicheDatenUnternehmensdatenProps {
    data: any;
}

export interface DateneingabeBetrieblicheDatenUnternehmensdatenState {
    showDlgEditUser?: any;
    showEditUser: boolean;
    customDescription: JSX.Element;
    reloading: boolean;
    customFormConfig: any;
    refreshStamp: number;
    showDialog: string;
    bundleFilterFunc: (bundle: any) => void;
}

export class DateneingabeBetrieblicheDatenUnternehmensdaten extends
    React.Component<DateneingabeBetrieblicheDatenUnternehmensdatenProps, DateneingabeBetrieblicheDatenUnternehmensdatenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showEditUser: false,
            customDescription: undefined,
            reloading: false,
            customFormConfig: null,
            bundleFilterFunc: null,
            refreshStamp: 0,
            showDialog: null
        };
        this.onFormChangeInteractive = this.onFormChangeInteractive.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.callBeforeOnFormAutoSave = this.callBeforeOnFormAutoSave.bind(this);
        this.getTochtergesellschaftenBtn = this.getTochtergesellschaftenBtn.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private lastAdressString: string = undefined;
    private lastGewerk: number;
    private lastBereichKey: string;
    private gewerkName: string;

    componentDidMount(): void {
        this.setHauptsitzdatenInUnternehmen();
        this.setCustomFormConfig();
    }

    setCustomFormConfig() {
        const { data } = this.props;
        const untData = data[IDs.ENT_UNTERNEHMENSDATEN];
        const bereichKey = Array.isArray(untData) && untData.length > 0 ? untData[0].bereich_key_orig : null;
        const breiche = data[IDs.ENT_BRANCHEN_BEREICHE];
        const breFnd = (breiche || []).find((r: any) => r.intern_key === bereichKey);
        const isAdmin = this.apiService.isAdmin();
        const konfigs = data[IDs.ENT_KONFIGURATION];
        const beraterZugriff = Array.isArray(konfigs) && konfigs.length > 0 ? konfigs[0].berater_zugriff_orig === 1 : false;
        const sit_count = this.getSitCount();
        const gewerk: number = Array.isArray(untData) && untData.length > 0 ? untData[0].gewerk_tid_orig : null;
        const privat_flag: boolean = bereichKey === 'privat';
        this.gewerkName = breFnd ? breFnd.name_gewerk : 'Gewerk';
        const customFormConfig: any = {
            gewerk_tid: { label: this.gewerkName, readonly: !bereichKey },
            wz_tid: {
                hidden: gewerk === 147 /* Kein Handwerk *//* || gewerk === 148 *//* Handwerkskammer */ || privat_flag,
                required: gewerk !== 147/* && gewerk !== 148*/ && !privat_flag
            },
            ort_gtz: { hidden: !isAdmin },
            betriebliche_situation: { hidden: sit_count !== 2 },
            ansprechpartner: { hidden: !beraterZugriff || privat_flag },
            mitgliedsnummer: { hidden: bereichKey !== 'handwerk' },
            datei_logo: { hidden: privat_flag }
        };
        if (bereichKey === 'sonstige') {
            customFormConfig.wz_tid.bundle_output = ['B:WZ 2008:', 'code_2008', 'bezeichnung_2008'];
        }
        const bundleFilterFunc = (bundle: any) => {
            bundle.gewerk_tid = (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || []).filter((r: any) => r.bereich_key_orig === bereichKey);
            bundle.wz_tid = this.props.data[IDs.ENT_GEWERKE_WZ];
            bundle.bundesland = this.props.data[IDs.ENT_BUNDESLAND];
            return bundle;
        }
        this.setState({ customFormConfig, bundleFilterFunc }, () => {
            this.lastBereichKey = bereichKey;
            this.lastGewerk = gewerk;
        });
    }

    getSitCount() {
        const { data } = this.props;
        const wz = getWZobject(data);
        let gew = getGewerkName(data);
        gew = (gew + '').trim().toLowerCase();
        const sit_count = !wz ? 0 : ((+wz.taetigkeit_kunden_bausstelle || 0) + (+wz.taetigkeit_ladengeschaeft || 0) + (+wz.taetigkeit_werkstatt_produktionsstaette || 0));
        return sit_count;
    }

    async onFormChangeInteractive(formData: WFormData, onValueChange: (name: string, value: any) => void): Promise<void> {
        this.lastAdressString = await getWetterstation(this.props.data, this.lastAdressString, formData, onValueChange);
        // console.log('onFormChangeInteractive', formData, this.lastAdressString);
    }

    render(): JSX.Element {
        const data = this.props.data[IDs.ENT_UNTERNEHMENSDATEN];
        const unternehmen: any = (data || [])[0] || {};
        const tid = (Array.isArray(data) && data.length > 0) ? data[0].tid : null;
        if (!tid) {
            return <div>Lade ...</div>;
        }
        const enableWeitereGewerke: boolean = config.devFeaturesMap && config.devFeaturesMap.N117_WEITERE_GEWERKE ? true : false;
        const showWeitereGewerke: boolean = enableWeitereGewerke && (unternehmen.bereich_key_orig || unternehmen.bereich_key) !== 'privat'
            && [147, 148].indexOf(+(unternehmen.gewerk_tid_orig || unternehmen.gewerk_tid)) === -1;
        if (!this.lastAdressString && data && data.length > 0) {
            const plz: string = data[0].plz || null;
            if (plz && +plz > 0) {
                this.lastAdressString = plz;
            }
        }
        const sit_count = this.getSitCount();
        const isAdmin = this.apiService.isAdmin();
        const customFormConfig: any = this.state.customFormConfig || {};
        const styleAdminOnly: React.CSSProperties = { color: '#aaa' };
        customFormConfig.bereich_key = { hidden: !isAdmin, disabled: !isAdmin, readonly: !isAdmin };

        // WKETOOL-139: Folien 19
        let hat_tochter = false;
        const modulSelected: string = (this.props.data || {}).MODUL_SELECTED;
        if (modulSelected === 'cfm') {
            const untData: any[] = this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [];
            hat_tochter = untData.some((d: any) => d.hat_tochtergesellschaften_orig === 1);
            customFormConfig.rechtsform = { hidden: false };
            customFormConfig.hat_tochtergesellschaften = { hidden: false };
            customFormConfig.tochtergesellschaften = {
                hidden: !hat_tochter,
                custom_component: this.getTochtergesellschaftenBtn,
                event_handler: this.getFormEventHandler()
            };
        }
        const customCssStyle: any = {
            formcontainer: { marginLeft: 10 },
            label: {
                bereich_key: styleAdminOnly
            }
        };

        const formGroupOrder = [
            {
                foldable: false,
                folded: false,
                fields: ['bereich_key', 'gewerk_tid', 'wz_tid', 'betriebliche_situation', 'name', 'rechtsform', 'hat_tochtergesellschaften', 'tochtergesellschaften', 'plz', 'ort']
            },
            {
                title: 'Optionale Daten',
                titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                foldable: true,
                folded: true,
                fields: ['strasse', 'hausnummer', 'bundesland', 'ort_gtz', 'telefon', 'fax', 'email', 'mitgliedsnummer', 'ansprechpartner', 'datei_logo']
            }
        ];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, minHeight: 0 }}>
                    <div
                        style={{
                            display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', maxWidth: 600
                        }}
                    >
                        {this.state.reloading ?
                            <WSpinner />
                            : <WFormsTableWrapper
                                forcedFormKey={['unt_daten', sit_count, hat_tochter].join('_')}
                                entity={IDs.ENT_UNTERNEHMENSDATEN}
                                module={IDs.MOD_ETOOL}
                                directEditFormularOf={{ tid: tid }}
                                inlineFormular={true}
                                customClass='Custom-ETA'
                                customFormConfig={customFormConfig}
                                formLayout='flowV2'
                                formLayout2='assistent'
                                customCssStyle={customCssStyle}
                                formAutoSave={true}
                                validateField={this.validateField}
                                globalData={this.props.data}
                                onFormChangeInteractive={this.onFormChangeInteractive}
                                onFormChange={this.onFormChange}
                                bundleFilterFunc={this.state.bundleFilterFunc}
                                refreshStamp={this.state.refreshStamp}
                                externalFormDescriptionElement={this.state.customDescription ? this.state.customDescription : <span></span>}
                                extraFormElementAfter={{
                                    wz_tid: showWeitereGewerke && <DateneingabeBetrieblicheDatenWeitereGewerke
                                        data={this.props.data}
                                    />
                                }}
                                callBeforeOnFormAutoSave={this.callBeforeOnFormAutoSave}
                                onSaveDone={() => {
                                    this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN, (data: any) => {
                                        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN])) {
                                            const row = data[IDs.ENT_UNTERNEHMENSDATEN].find((r: any) => r.tid === tid);
                                            if (row) {
                                                this.setHauptsitzdaten(row);
                                            }
                                        }
                                    });
                                }}
                                formGroupOrder={formGroupOrder}
                            />}
                    </div>
                </div>
                {this.state.showEditUser &&
                    <EditUser
                        data={this.props.data}
                        onClose={() => this.setState({ showEditUser: false })}
                    />
                }
            </div>
        );
    }

    onFormChange(WFormData: any) {
        const { data } = this.props;
        const { customFormConfig, refreshStamp } = this.state;
        onFormChangeUniversal(IDs.ENT_UNTERNEHMENSDATEN, WFormData, this, this.props.data);
        const bereichKey = WFormData.getValue('bereich_key');
        if (this.lastBereichKey !== bereichKey) {
            WFormData.setValue('gewerk_tid', null);
            const breiche = data[IDs.ENT_BRANCHEN_BEREICHE];
            const breFnd = (breiche || []).find((r: any) => r.intern_key === bereichKey);
            customFormConfig.gewerk_tid = {
                label: breFnd ? breFnd.name_gewerk : 'Gewerk',
                readonly: !bereichKey
            };
            const bundleFilterFunc = (bundle: any) => {
                bundle.gewerk_tid = (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || []).filter((r: any) => r.bereich_key_orig === bereichKey);
                return bundle;
            };
            this.setState({ customFormConfig, bundleFilterFunc, refreshStamp: refreshStamp + 1 }, () => this.lastBereichKey = bereichKey);
        }

        // WKETOOL-10 "Wirtschaftszweig / Tätigkeitsprofil" ausblenden, wenn "Kein Handwerk" gewählt ist
        const gewerk: number = WFormData.getValue('gewerk_tid');
        if (this.lastGewerk !== gewerk) {
            if (gewerk === 147 /* Kein Handwerk *//* || gewerk === 148 *//* Handwerkskammer */ || bereichKey === 'privat') {
                customFormConfig.wz_tid = { hidden: true, required: false };
            } else {
                customFormConfig.wz_tid = { hidden: false, required: true };
            }
            this.setState({ customFormConfig, refreshStamp: refreshStamp + 1 }, () => this.lastGewerk = gewerk);
        }

        this.setCustomDescription(WFormData.getAllValues());

        // Wir triggern das Update-Event um die lokalen Daten sofort zu ändern, ohne zu warten.
        // Natürlich kommen später noch der Datensatz aus dem Server.
        const update: any = {
            [IDs.ENT_UNTERNEHMENSDATEN]: {
                tid: WFormData.getValue('tid'),
                name: WFormData.getValue('name'),
                plz: WFormData.getValue('plz')
            }
        };
        this.triggerService.fire('updateLocalDataByEntity', 'dataObject', update);
        return '';
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_UNTERNEHMENSDATEN, key, value, data, onValueChange, this.props.data);
    }

    setHauptsitzdaten(unt: any): void {
        const { data } = this.props;
        const hauptsitz: any = (data[IDs.ENT_STANDORT] || [])
            .find((r: any) => r.standort_typ_tid_orig === 1 || r.standort_typ_tid === 1) || {};
        let values: any = {};
        values.tid = +hauptsitz.tid || null;
        if (values.tid) {
            let changeCnt = 0;
            ['strasse', 'hausnummer', 'ort', 'plz', 'ort_gtz'].forEach((k: string) => {
                if ((hauptsitz[k] || '') !== (unt[k] || '')) {
                    values[k] = unt[k];
                    changeCnt++;
                }
            });
            if (changeCnt > 0) {
                this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_STANDORT, values, (res: any) => {
                    this.triggerService.fire('reload', IDs.ENT_STANDORT);
                });
            }
        }
    }

    setHauptsitzdatenInUnternehmen(): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0 &&
            Array.isArray(data[IDs.ENT_STANDORT]) && data[IDs.ENT_STANDORT].length > 0) {
            const hauptsitz = data[IDs.ENT_STANDORT].find((r: any) => r.standort_typ_tid_orig === 1 || r.standort_typ_tid === 1);
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            if (hauptsitz && unt) {
                const newVals: any = { tid: unt.tid };
                let changeCnt = 0;
                ['strasse', 'hausnummer', 'ort', 'plz', 'ort_gtz'].forEach((k: string) => {
                    if (hauptsitz[k] && unt[k] !== hauptsitz[k]) {
                        unt[k] = hauptsitz[k];
                        newVals[k] = hauptsitz[k];
                        changeCnt++;
                    }
                });
                if (changeCnt > 0) {
                    this.setState({ reloading: true }, () =>
                        this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_UNTERNEHMENSDATEN, newVals, () => this.setState({ reloading: false }))
                    );
                }
            }
        }
    }

    getInfo(key: string) {
        const msg: any = {
            gewerkErr1: 'Bitte ein Gewerk auswählen!',
            gewerkErr2: 'Sofern Ihre Tätigkeiten mehrere Gewerke umfassen, bitte das "Hauptgewerk" wählen.',
            plzErr1: 'Bitte eine gültige Postleitzahl eintragen!',
            plzErr2: 'Ohne diese Angabe kann die automatische Witterungsbereinigung für Wärmeverbräuche nicht berechnet werden. Mehr dazu erfahren Sie in der Auswertung der Wärmedaten.'
        }
        return msg[key];
    }

    callBeforeOnFormAutoSave(formData: any, callback: () => void) {
        const gewerkErr = this.gewerkName === 'Gewerk' && !(formData || {}).gewerk_tid;
        const plzErr = validateFieldUniversal(IDs.ENT_UNTERNEHMENSDATEN, 'plz', (formData || {}).plz, formData, () => { });
        const errMsg: string[] = [];
        if (gewerkErr) {
            errMsg.push(this.getInfo('gewerkErr1') + ' ' + this.getInfo('gewerkErr2'));
        }
        if (plzErr) {
            errMsg.push(this.getInfo('plzErr1') + ' ' + this.getInfo('plzErr2'));
        }
        if (errMsg.length > 0) {
            alert(errMsg.join("\n\n"));
        } else {
            callback();
        }
    }

    setCustomDescription(formData: any) {
        const msgStyle: React.CSSProperties = { backgroundColor: '#fee', padding: 3, borderRadius: 5, textAlign: 'center', color: '#a77', border: '1px solid #faa' };
        const gewerErrkMsg = (
            <div style={{ ...msgStyle, marginBottom: 3 }}>
                {this.getInfo('gewerkErr1')}<br />
                <span style={{ fontSize: 12 }}>{this.getInfo('gewerkErr2')}</span>
            </div>
        );
        const plzErrkMsg = (
            <div style={{ ...msgStyle }}>
                {this.getInfo('plzErr1')}<br />
                <span style={{ fontSize: 12 }}>{this.getInfo('plzErr2')}</span>
            </div>
        );
        const errMsg: JSX.Element[] = [];
        const gewerkErr = this.gewerkName === 'Gewerk' && !(formData || {}).gewerk_tid;
        const plzErr = validateFieldUniversal(IDs.ENT_UNTERNEHMENSDATEN, 'plz', (formData || {}).plz, formData, () => { });
        if (gewerkErr) {
            errMsg.push(gewerErrkMsg);
        }
        if (plzErr) {
            errMsg.push(plzErrkMsg);
        }
        if (errMsg.length > 0) {
            this.setState({ customDescription: <div>{errMsg}</div> });
        } else {
            this.setState({ customDescription: null });
        }
    }

    getTochtergesellschaftenBtn() {
        const untData: any = (this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        const tochtergesellschaftenTid = parseInt(untData.tochtergesellschaften_orig || untData.tochtergesellschaften) || 0;
        let btnStyle: any = { marginLeft: 5, marginRight: 0 };
        const directDialog = this.state.showDialog === 'addTochtergesellschaft';
        const reloadFunc = () => {
            this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN, () => {
                const bundleFilterFunc = (bundle: any) => {
                    bundle.tochtergesellschaften = this.props.data[IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN];
                    return bundle;
                };
                this.setState({ bundleFilterFunc, refreshStamp: this.state.refreshStamp + 1 });
            });
        };
        return <FormBtnTochtergesellschaften
            data={this.props.data}
            tochterTid={directDialog ? 0 : tochtergesellschaftenTid}
            btnDisabled={this.state.reloading}
            btnStyle={btnStyle}
            directDialog={directDialog}
            onDelDone={reloadFunc}
            onSaveDone={reloadFunc}
            onClose={() => this.setState({ showDialog: null })}
        />;
    }

    getFormEventHandler() {
        return {
            onMenuOpen: (params?: any) => {
                const bundle = (params || {}).bundleData;
                if (Array.isArray(bundle) && bundle.length === 0) {
                    setTimeout(() => this.setState({ showDialog: 'addTochtergesellschaft' }), 100);
                }
            }
        };
    }
}
